import { History, Info } from 'lucide-react';

import type { IdeaDetail } from '@/api/types';

import { DispositionPill } from '../ideaUi';
import { ResearchStatusPill } from '@/ui/ResearchStatusPill';
import { IdeaActions } from './IdeaActions';
import { IndustryControl } from './IndustryControl';
import type { IdeaDetailUi } from './useIdeaDetail';

/** The facts card: industry, status and research state, with the Submission and History dialogs and the page actions on the right. */
export function IdeaFacts({ idea, ui }: { idea: IdeaDetail; ui: IdeaDetailUi }) {
  return (
    <div className="card idea-facts">
      <div className="idea-facts-main">
        <span className="idea-fact">
          <span className="label">Industry</span>
          <IndustryControl idea={idea} editing={ui.editingIndustry} onEditing={ui.setEditingIndustry} />
        </span>
        <span className="idea-fact">
          <span className="label">Status</span>
          <DispositionPill disposition={idea.disposition} />
        </span>
        {idea.research_status !== 'scored' && (
          <span className="idea-fact">
            <span className="label">Research</span>
            <ResearchStatusPill status={idea.research_status} />
          </span>
        )}
      </div>
      <div className="idea-facts-links">
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => ui.setPanel('submission')}>
          <Info aria-hidden="true" /> Submission
        </button>
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => ui.setPanel('history')}>
          <History aria-hidden="true" /> History
          <span className="count">{idea.history.length}</span>
        </button>
        <span className="filter-divider" aria-hidden="true" />
        <IdeaActions idea={idea} ui={ui} />
      </div>
    </div>
  );
}
